const config = {
	pageSize: 20,
	queryParams: [
		{
			param: "status",
			type: "",
		},
		{
			param: "page",
			type: "",
		},
	],
};

export default config;
